"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StoreRedirect',
  mounted: function mounted() {
    var _this = this;
    // 重定向到新的店铺管理页面
    setTimeout(function () {
      _this.$router.push('/rs/merchant/store');
    }, 1000);
  }
};